import axios from 'axios';

const agent = axios.create({
  //baseURL:'https://apistaging.kassa.co',
  baseURL: 'https://api.kassa.co/',
  headers: {
    'Accept': 'application/json',
    'X-App-Client': 'Android',
    'X-App-Version': 130,
    'X-App-Unique-Code': '235e0e46-1441-40e6-b660-148770d3787e',
    'Content-Type': 'application/json',
  }
})

const send = ({ data, headers, method, params, responseType, url, timeout }) => {
  const mergedHeaders = {
    //...{ Authorization: token ? `Bearer ${token}` : undefined },
    ...headers
  };
  return agent.request({
    data,
    headers: mergedHeaders,
    method,
    params,
    url,
    responseType,
    timeout: timeout || 0
  }).catch((error) => {
    console.log('Failed to send.', error);
    if (error && error.message && error.message.includes('timeout')) {
      throw new Error('timeout');
    }
    else if (error && error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx.
      if (error.response.data && error.response.data.error) {
        throw new Error(JSON.stringify(error.response.data.error));
      } else if (error.response.data) {
        throw new Error(JSON.stringify(error.response.data));
      }
    } else if (error.request) {
      // The request was made but no response was received.
      throw new Error('Unknown Error');
    } else {
      // Something happened while setting up the request.
      throw new Error('Something went wrong. Please try again.');
    }
  });
};

export { send };